import moment from "moment";
import { FilterTimeFrameValue } from "server/config-api/index.js";

import { type TimeFilter, defaultTimeFilter } from "../../DatePicker/constants";

const getBuildingTrendTimeFrame = (
  period: FilterTimeFrameValue,
  timezone: string,
): TimeFilter => {
  const endTimeISO = moment().tz(timezone, true).endOf("day").toISOString();

  if (period === FilterTimeFrameValue.SinceBeginning) {
    return { startTimeISO: "2017-01-01T00:00:00Z", endTimeISO };
  }

  return {
    startTimeISO: moment()
      .tz(timezone, true)
      .subtract(12, "months")
      .startOf("day")
      .toISOString(),
    endTimeISO,
  };
};

export const getPeriodFilterValue = ({
  period,
  timezone,
}: {
  period: FilterTimeFrameValue;
  timezone: string;
}) => {
  const defaultValue = getBuildingTrendTimeFrame(period, timezone);

  return {
    startTimeISO: defaultValue.startTimeISO,
    endTimeISO: moment().tz(timezone, true).endOf("month").toISOString(),
  };
};

export const getPreviousYearFilterValue = ({
  periodFilterValue,
  period,
  timezone,
}: {
  periodFilterValue: TimeFilter;
  period: FilterTimeFrameValue;
  timezone: string;
}) => {
  if (period !== FilterTimeFrameValue.Last12Months) {
    return defaultTimeFilter;
  }

  return {
    startTimeISO: moment(periodFilterValue.startTimeISO)
      .tz(timezone, true)
      .subtract(1, "year")
      .startOf("day")
      .toISOString(),
    endTimeISO: moment(periodFilterValue.endTimeISO)
      .tz(timezone, true)
      .subtract(1, "year")
      .endOf("day")
      .toISOString(),
  };
};
